import { useState } from 'react';
import { api } from '../lib/api';
import AgentSettings from '../components/AgentSettings';
import { ErrorNote, useLoad } from '../components/ui';

const fmt = (iso: string) => new Date(`${iso}T12:00:00`).toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric' });

// A short reading of yesterday every morning: what sold, what came in, what needs your attention.
export default function MorningSummary() {
  const list = useLoad(() => api<any[]>('/api/briefs'), []);
  const [pick, setPick] = useState<string | null>(null);
  const id = pick ?? list.data?.[0]?.id ?? null;
  const one = useLoad(() => (id ? api<any>(`/api/briefs/${id}`) : Promise.resolve(null)), [id]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState<unknown>(null);
  const b = one.data?.brief;
  const section = (title: string, xs: string[], tone?: string) => (xs?.length ? <div><h3 style={{ margin: '14px 0 4px' }}>{title}</h3><ul style={{ margin: 0, paddingLeft: 20 }}>{xs.map((x, i) => <li key={i} style={tone ? { color: tone } : undefined}>{x}</li>)}</ul></div> : null);
  return (
    <div className="stack">
      <div className="page-head"><div className="grow"><h1>Daily AI Business Insights</h1><p>Every morning, a short reading of yesterday's sales and orders, and what needs your attention. It is also emailed if you set an address below.</p></div>
        <button className="primary" disabled={busy} onClick={async () => { setBusy(true); setErr(null); setMsg(''); try { const r = await api<any>('/api/briefs/generate', { body: {} }); setPick(r.id); list.reload(); } catch (e) { setErr(e); } finally { setBusy(false); } }}>{busy ? 'Working…' : "Make yesterday's summary now"}</button></div>
      <ErrorNote error={err ?? list.error ?? one.error} />
      {msg && <div className="notice good">{msg}</div>}
      <div className="grid-2" style={{ display: 'grid', gap: 16, gridTemplateColumns: 'minmax(0, 2fr) minmax(220px, 1fr)' }}>
        <div className="panel"><div className="panel-body">
          {!b && <div className="empty">No summary yet. Press the button to make yesterday's, or wait for tomorrow morning.</div>}
          {b && (
            <div>
              <div className="faint">{fmt(one.data.for_date)} · {one.data.ai_used ? 'written by the AI helper' : 'plain summary'}</div>
              <h2 style={{ margin: '4px 0 8px' }}>{b.headline}</h2>
              <p>{b.summary}</p>
              {section('Highlights', b.highlights)}
              {section('Keep an eye on', b.watch, 'var(--bad)')}
              {section('To do', b.todo)}
              <div className="row" style={{ marginTop: 14, gap: 8 }}>
                <button onClick={async () => { setErr(null); try { const r = await api<any>(`/api/briefs/${one.data.id}/email`, { body: {} }); setMsg(r.result); one.reload(); } catch (e) { setErr(e); } }}>Email this to me</button>
                {one.data.emailed_at && <span className="faint">Emailed {new Date(one.data.emailed_at).toLocaleString()}</span>}
              </div>
            </div>)}
        </div></div>
        <div className="panel"><div className="panel-head"><h2>Earlier</h2></div><div className="panel-body" style={{ maxHeight: 360, overflow: 'auto' }}>
          {list.data?.map((x) => <button key={x.id} className={`ghost ${x.id === id ? 'primary' : ''}`} style={{ display: 'block', width: '100%', textAlign: 'left' }} onClick={() => setPick(x.id)}>{fmt(x.for_date)}<div className="faint">{x.headline}</div></button>)}
          {list.data?.length === 0 && <div className="empty">Nothing yet.</div>}
        </div></div>
      </div>
      <AgentSettings which="brief" />
    </div>
  );
}
